export const API_STATUSES = Object.freeze({
  REQUEST: "request",
  PENDING: "pending",
  SUCCESS: "success",
  ERROR: "error",
  IDLE: "idle"
});